import React, {PropTypes, Component} from 'react'
import moment from 'moment'

class AttendTime extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    attendenceInfo: PropTypes.object.isRequired
  }

  renderCheckInTime(){
    let {attendenceInfo} = this.props
    let {lesson_start_datetime, lesson_end_datetime, check_in_datetime} = attendenceInfo

    if(!check_in_datetime){
      return '––'
    } else if (moment(lesson_start_datetime).format('YYYY-MM-DD') == moment(check_in_datetime).format('YYYY-MM-DD')){
      return(
        <span>{moment(check_in_datetime).format('HH:mm')}</span>
      )
    } else {
      return(
        <div>
          <span>{moment(check_in_datetime).format(__('MMM DD, YYYY', 'dateFormat'))}</span>
          <span style={{paddingLeft: '5px'}}>{moment(check_in_datetime).format('HH:mm')}  </span>
        </div>
      )
    }
  }

  render(){
    return(
      <div className='class-status'>
        {this.renderCheckInTime()}
      </div>
    )
  }
}


export default (AttendTime)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/AttendTime.js